import * as React from 'react';
const SvgYoutubeBumper = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={88}
    height={88}
    fill="none"
    viewBox="0 0 88 88"
    {...props}
  >
    <g clipPath="url(#a)">
      <path fill="#fff" fillOpacity={0.01} d="M0 0h88v88H0z" />
      <rect width={88} height={88} fill="#fff" rx={4} />
      <path
        fill="#16E"
        d="M4 28a2 2 0 0 1 2-2h76a2 2 0 0 1 2 2v40a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
        opacity={0.6}
      />
      <rect
        width={79}
        height={43}
        x={4.5}
        y={26.5}
        stroke="currentColor"
        strokeOpacity={0.14}
        rx={1.5}
      />
      <rect
        width={40}
        height={2}
        x={4}
        y={20}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={64}
        height={2}
        x={4}
        y={16}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={12}
        height={2}
        x={14}
        y={9}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={22}
        height={2}
        x={14}
        y={5}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.8}
        rx={1}
      />
      <rect
        width={8}
        height={8}
        x={4}
        y={4}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.8}
        rx={2}
      />
      <rect
        width={87}
        height={87}
        x={0.5}
        y={0.5}
        stroke="currentColor"
        strokeOpacity={0.14}
        rx={3.5}
      />
      <path
        fill="#fff"
        d="M38.2 55.611c-.2-.26-.2-.73-.2-1.66v-11.9c0-.93 0-1.4.2-1.66.07-.1.16-.18.26-.24.13-.08.29-.14.46-.15.33-.02.73.23 1.52.74l9.335 5.95c.69.44 1.03.66 1.15.94a1 1 0 0 1 0 .76c-.12.28-.46.5-1.15.94l-9.334 5.93c-.79.51-1.19.76-1.52.74a.97.97 0 0 1-.72-.39"
      />
      <rect
        width={16}
        height={2}
        x={4}
        y={78}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={32}
        height={2}
        x={4}
        y={74}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={13}
        height={5}
        x={70.5}
        y={74.5}
        stroke="currentColor"
        strokeOpacity={0.14}
        rx={0.5}
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M72.4 59a2.4 2.4 0 0 0-2.4 2.4v4.2a2.4 2.4 0 0 0 2.4 2.4h7.2a2.4 2.4 0 0 0 2.4-2.4v-4.2a2.4 2.4 0 0 0-2.4-2.4zm.979 6.947q.312.11.65.113.484.002.852-.192.368-.196.573-.541.207-.345.207-.789 0-.409-.175-.726a1.3 1.3 0 0 0-1.168-.682q-.238 0-.454.075-.213.072-.381.21-.166.137-.264.33h-.03q.004-.636.224-1.007a.71.71 0 0 1 .647-.37q.252-.001.422.13a.6.6 0 0 1 .224.357h.91a1.42 1.42 0 0 0-.784-1.108 1.7 1.7 0 0 0-.772-.17q-.405 0-.73.16a1.6 1.6 0 0 0-.56.46 2.2 2.2 0 0 0-.359.737 3.6 3.6 0 0 0-.126.982q0 .6.143 1.01.146.412.392.66.247.25.559.36m1.026-.714a.7.7 0 0 1-.38.102.7.7 0 0 1-.382-.104.77.77 0 0 1-.36-.665q0-.158.057-.296a.744.744 0 0 1 .394-.413q.137-.06.296-.06a.71.71 0 0 1 .64.377.8.8 0 0 1 .096.39.8.8 0 0 1-.096.392.73.73 0 0 1-.264.277m3.81-1.521.831-.052a1.01 1.01 0 0 0-.417-.713q-.357-.262-.976-.262-.42 0-.733.123-.312.124-.484.352a.88.88 0 0 0-.17.543q0 .366.232.603.234.237.714.332l.566.113a.75.75 0 0 1 .316.124.25.25 0 0 1 .104.202q-.002.148-.149.241a.7.7 0 0 1-.384.092.7.7 0 0 1-.398-.102.46.46 0 0 1-.196-.303l-.893.047q.066.469.45.741.386.27 1.035.27.426 0 .752-.133.33-.137.516-.38a.9.9 0 0 0 .19-.564.74.74 0 0 0-.235-.571q-.234-.217-.711-.316l-.593-.119q-.228-.05-.321-.13a.25.25 0 0 1-.094-.198q0-.147.145-.234a.67.67 0 0 1 .356-.09.6.6 0 0 1 .27.053q.115.051.186.139.07.085.091.192"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h88v88H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgYoutubeBumper;
